var React = require('react');

function IconWarning (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#EA534F","d":"M.792 16.625h17.416L9.5 1.583.792 16.625zm9.5-2.375H8.707v-1.583h1.583v1.583zm0-3.167H8.707V7.917h1.583v3.166z"}));
}

IconWarning.defaultProps = {"width":"19","height":"19","fill":"none","viewBox":"0 0 19 19"};

module.exports = IconWarning;

IconWarning.default = IconWarning;
